import { render, staticRenderFns } from "./BaseVimeoVideo.vue?vue&type=template&id=2d6ac936&"
import script from "./BaseVimeoVideo.vue?vue&type=script&lang=js&"
export * from "./BaseVimeoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6ac936')) {
      api.createRecord('2d6ac936', component.options)
    } else {
      api.reload('2d6ac936', component.options)
    }
    module.hot.accept("./BaseVimeoVideo.vue?vue&type=template&id=2d6ac936&", function () {
      api.rerender('2d6ac936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseVimeoVideo.vue"
export default component.exports